import {
  createHubFilterStore,
  useGenericActiveProjectHubFilterCount,
  useGenericHasProjectHubFilters,
} from '@/shared/hooks/use-hub-filter-store';

export const useOrgMemberFilterStore = createHubFilterStore();
export const useActiveOrgMemberFilterCount = () =>
  useGenericActiveProjectHubFilterCount(useOrgMemberFilterStore());
export const useHasOrgMemberFilters = () =>
  useGenericHasProjectHubFilters(useOrgMemberFilterStore());
